import { createSelector } from "reselect";

export const getAddressState = (state) => state.shopping.addresses;

export const getAddressList = createSelector(getAddressState, (state) => state.addresses);
export const getIsAddressListFetching = createSelector(getAddressState, (state) => state.isFetching);

export const CUSTOMER = "customer";
export const GOODS_RECIPIENT = "goodsRecipient";

export const addressListSelectors = {
  [CUSTOMER]: createSelector(getAddressList, (addresses) => addresses.filter((address) => address.type === CUSTOMER)),
  [GOODS_RECIPIENT]: createSelector(getAddressList, (addresses) => addresses.filter((address) => address.type === GOODS_RECIPIENT)),
};
